export const stores = [
  { id:1, name:"Riverside Ford",    location:"Fredericksburg, VA", score:68, alerts:3,  color:"#2563eb", status:"At Risk"  },
  { id:2, name:"Capital Chevrolet", location:"Stafford, VA",       score:74, alerts:1,  color:"#16a34a", status:"At Risk"  },
  { id:3, name:"Northern Toyota",   location:"Woodbridge, VA",     score:61, alerts:5,  color:"#dc2626", status:"Bleeding" },
  { id:4, name:"Blue Ridge Dodge",  location:"Warrenton, VA",      score:55, alerts:7,  color:"#dc2626", status:"Bleeding" },
];
